import axios from 'axios'
import { Toast } from 'vant'
import { trimParams } from '@/utils/index'

// 创建axios实例
const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_URL + 'api', // api 的 base_url
    timeout: 50000, // 请求超时时间
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
    }
})

// request拦截器
service.interceptors.request.use(
    config => {

        if (config.headers['Content-Type'] === 'multipart/form-data') {
            //config.data.set('token', token);
            //return config;
        }
        // 判断请求的类型：如果是post请求就把默认参数拼到data里面；如果是get请求就拼到params里面
        if (config.method === 'post') {
            config.data = trimParams({
                'service-key': 'c8b94f05193b6f9b8664185f4978cd81',
                ...config.data
            })
        } else if (config.method === 'get') {
            var  data1 = config.params && config.params.params
            config.params = {
                //token: token,
                ...data1
            }
        }
        return config
    },
    error => {
        console.log(error) // debug
        Promise.reject(error)
    }
)

// response 拦截器
service.interceptors.response.use(
    response => {
        if (response.data.status === 501) {
            Toast.fail('失败~')
            setTimeout(() => {
                window.location = '/'
            }, 1000)
            return Promise.reject(response.data)
        }
        return response.data;
    },
    error => {
        return Promise.reject(error)
    }
)

export function get(url, params = {}) {
    return service.get(url, { params: trimParams(params) })
}

export function post(url, data = {}) {
    return service.post(url, data)
}

export function patch(url, data = {}) {
    return service.patch(url, data)
}
export function del(url, data = {}) {
    return service.delete(url, data)
}
export function put(url, data = {}) {
    return service.put(url, data)
}
export function upload(url, formData) {
    return service.post(url, formData, {
        headers: {
            "Content-Type": "multipart/form-data"
        }
    })
}

export default service